/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ApplicationsInputs */

const en_applications = /** @type {(inputs: ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applications`)
};

const de_applications = /** @type {(inputs: ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbungen`)
};

/**
* | output |
* | --- |
* | "Applications" |
*
* @param {ApplicationsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const applications = /** @type {((inputs?: ApplicationsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ApplicationsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applications(inputs)
	return en_applications(inputs)
});